import CryptoJS from "crypto-js";

export const createSignature = (secret: string, data: object): string => {
  const payload = JSON.stringify(data);
  return CryptoJS.HmacSHA256(payload, secret).toString(CryptoJS.enc.Hex);
};
